<template>
  <div class="chat-list-box">
    <DynamicScroller ref="scroller_box" :items="list" :min-item-size="54" class="scroller">
      <template v-slot="{ item, index, active }">
        <DynamicScrollerItem :item="item" :active="active" :size-dependencies="[item.message,]" :data-index="index">
          <div class="list-item">
            <div class="message gift" v-if="item.type === 'gift'">

              <div class="gift flower" v-if="item.gift_type === 'flower'">
                <div class="name">{{ item.name }}</div>
                <div class="content">{{ item.message }}</div>
                <div class="img"><img :src="require('@/assets/images/live/playing/chat_flower.png')"></div>
              </div>

              <div class="gift like" v-else-if="item.gift_type === 'like'">
                <div class="name">{{ item.name }}</div>
                <div class="content">{{ item.message }}</div>
                <div class="img"><img :src="require('@/assets/images/live/playing/chat_zan.png')"></div>
              </div>

              <div class="gift amazing" v-else-if="item.gift_type === 'amazing'">
                <div class="name">{{ item.name }}</div>
                <div class="content">{{ item.message }}</div>
                <div class="img"><img :src="require('@/assets/images/live/playing/chat_666.png')"></div>
              </div>

            </div>

            <div class="message question" v-else-if="item.type === 'question'">
              <p>
                <span class="tag">[提问]</span>
                <span class="detail">{{ item.name }}:</span>
                <span class="content">{{ item.message }}</span>
              </p>
            </div>

            <div class="message teacher" v-else-if="item.type === 'teacher'">
              <p>
                <span class="tag">[老师]</span>
                <span class="detail">{{ item.name }}:</span>
                <span class="content">{{ item.message }}</span>
              </p>
            </div>

            <div class="message text" v-else>
              <p>
                <span class="detail">{{ item.name }}:</span>
                <span class="content">{{ item.message }}</span>
              </p>
            </div>
          </div>
        </DynamicScrollerItem>
      </template>
    </DynamicScroller>
  </div>
</template>
<script>
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
export default {
  name: 'chat-list',
  props: {
    chatList: {
      type: Array,
      default: function () {
        return []
      }
    },
    showTeacher: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    }
  },
  components: {
    DynamicScroller,
    DynamicScrollerItem
  },
  computed: {
    list() {
      const temp = []
      if (this.showTeacher === false) {
        return this.chatList
      }

      this.chatList.map(function (item, key) {
        if (item.type && item.type === 'teacher') {
          temp.push(item)
        }
      })
      return temp
    }
  },
  watch: {
    list() {
      this.scrollToBottom()
    }
  },
  mounted() {
  },
  methods: {
    scrollToBottom() {
      this.$refs.scroller_box.scrollToBottom()
    },
    initHeight(height) {
      // alert(document.getElementsByClassName('scroller')[0].style.height)
      document.getElementsByClassName('scroller')[0].style.height = height + 'px'
    }
  }
}
</script>

<style scoped lang="scss">
.scroller {
  padding: .32rem .53rem;
  box-sizing: border-box;

  /*修改滚动条样式*/
  &::-webkit-scrollbar {
    width: 4px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f8f8;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #bfbfbf;
  }

  &::-webkit-scrollbar-corner {
    background: #179a16;
  }
}

.chat-list-box {
  overflow-y: auto;
  padding: 0;
  font-family: Microsoft YaHei;
  background-color: #f8f8f8;

  .list-item {
    .message {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: .16rem 0;

      .name {
        font-size: 12px;
        font-weight: 400;
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .content {
        font-size: 0.32rem;
        font-weight: 400;
      }

      .detail {
        min-width: 100%;
        font-size: 0.32rem;
        max-width: 118px;
        @include ellipsis(1);
      }

      .tag {
        padding: 0 3px;
      }
    }

    .message.text {
      .detail {
        color: #949699;
      }

      .content {
        color: #18191A;
        margin-left: .2rem;
      }
    }

    .message.teacher {

      .tag,
      .detail,
      .content {
        color: var(--main-color);
      }
    }

    .message.question {

      .tag,
      .detail,
      .content {
        color: #FF6A4D;
      }
    }
  }
}

.gift .gift {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.6rem;
  padding: 0 .32rem;
  border-radius: 0.4rem;
  color: #FF6A4D;
  background: linear-gradient(90deg, #FFF0ED 0%, #FBEEEE 100%);
  width: max-content;

  .name {
    max-width: 118px;
    @include ellipsis(1);
    font-size: 0.32rem;
  }

  .content {
    margin-left: .2rem !important;
  }

  .img {
    width: 0.61rem;
    height: 0.61rem;
    margin-left: .2rem;
  }
}
</style>
